class Base {
  updateDataByRecords() {
    return {};
  }

  getRequestParams() {
    return {};
  }

  getData() {
    return {};
  }

  resetOptions() {
    return {};
  }

  removeKeyFromData() {
    return {};
  }

  excludeStepDataFromParams(params) {
    return params;
  }

  getStepDataFromAppointment() {
    return {};
  }
}

export default Base;
